import * as angular from "angular";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { DialogUtils } from "../../helper/dialog.helper";

let BadgeHelpComponent = {
    selector: "vcBadgeHelp",
    templateUrl: "/angular/components/people/badge-number-Help.component.html",
    bindings: {
        showLocationNumbers: "=",
        pageName: "=",
        __env: "=",
    },
    controller: class BadgeHelpController {
        // * bindings for typescript compiler *
        public showLocationNumbers: any;
        public pageName: any;
        public __env: any;
        // ************************************

        private statuses: any;

        private dialog: DialogUtils;
        private canvassStatusDataProvider: CanvassStatusDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            CanvassStatusDataProvider: CanvassStatusDataProvider
        ) {
            this.dialog = DialogUtils;

            this.canvassStatusDataProvider = CanvassStatusDataProvider;

            this.canvassStatusDataProvider
                .walkCanvassStatuses()
                .then((statuses: any) => {
                    this.statuses = statuses;
                });
        }

        cancel() {
            this.dialog.cancel();
        }
    },
};

angular
    .module("people", [])
    .component(BadgeHelpComponent.selector, BadgeHelpComponent);
